module.exports = __webpack_public_path__ + "static/media/NutriGuide_user_manual_EN_LAT.800c89bd.pdf";